import { render, staticRenderFns } from "./overdue.vue?vue&type=template&id=d533dd6c&scoped=true&"
import script from "./overdue.vue?vue&type=script&lang=js&"
export * from "./overdue.vue?vue&type=script&lang=js&"
import style0 from "./overdue.vue?vue&type=style&index=0&id=d533dd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d533dd6c",
  null
  
)

export default component.exports